// extracted by mini-css-extract-plugin
export default {"Wrapper":"SurveyRecordsActions_Wrapper__4Me8j"};